import { MAX_CUSTOM_PRODUCT_NUMBER_INPUT_LENGTH } from "variables";
import type { KeyboardEvent, SyntheticEvent, ClipboardEvent } from "react";

export const allowOnlyNumberKeys = (e: KeyboardEvent<HTMLInputElement>) => {
  if (["e", "E", "+", "-"].includes(e.key)) {
    e.preventDefault();
  }
};

export const limitNumberInputLength = (e: SyntheticEvent<HTMLInputElement>) => {
  const input = e.currentTarget;
  if (input.value.length > MAX_CUSTOM_PRODUCT_NUMBER_INPUT_LENGTH) {
    input.value = input.value.slice(0, MAX_CUSTOM_PRODUCT_NUMBER_INPUT_LENGTH);
  }
};

export const handleNumberPaste = (e: ClipboardEvent<HTMLInputElement>) => {
  const pasted = e.clipboardData.getData("text");
  if (
    !/^[0-9.]+$/.test(pasted) ||
    pasted.length > MAX_CUSTOM_PRODUCT_NUMBER_INPUT_LENGTH
  ) {
    e.preventDefault();
  }
};
